import {
  SignatureRequest,
  SignatureRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { StepItem } from "../../../../../../shared/components/Steps";

/**
 * v1's dedicated `Pending` (signed, awaiting countersign) document status is a
 * first-class `AwaitingCountersignature` status on v3, so that stage no longer
 * has to be derived from the payee signer's own state.
 */
export const getSignatureRequestProgressSteps = (
  signatureRequest: SignatureRequest,
  isCounterSign?: boolean
): StepItem[] => {
  const status =
    signatureRequest.status ?? SignatureRequestStatus.AWAITING_SIGNATURE;

  if (status === SignatureRequestStatus.COMPLETED) {
    return [
      { title: "Sent", status: "Complete" },
      { title: "Sign", status: "Complete" },
      { title: "Complete", status: "Complete" }
    ];
  }

  if (status === SignatureRequestStatus.AWAITING_COUNTERSIGNATURE) {
    return [
      { title: "Sent", status: "Complete" },
      { title: "Sign", status: isCounterSign ? "Active" : "Complete" },
      { title: "Complete", status: "Pending" }
    ];
  }

  return [
    { title: "Sent", status: isCounterSign ? "Complete" : "Active" },
    { title: "Sign", status: isCounterSign ? "Active" : "Pending" },
    { title: "Complete", status: "Pending" }
  ];
};
